import { c as _c } from "react/compiler-runtime";
import { Button } from '@petsmart-ui/sparky';
import { useState } from 'react';
import { NavigationDrawer } from '@/components/Menu/NavigationDrawer';
import './navigation.scss';
export function Navigation() {
  const $ = _c(5);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsDrawerOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleDrawerOpen = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsDrawerOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDrawerClose = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button className="navigation-button" iconName="menu" onClick={handleDrawerOpen} size="sm" text="Button" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isDrawerOpen) {
    t3 = <>{t2}<NavigationDrawer isActive={isDrawerOpen} handleClose={handleDrawerClose} /></>;
    $[3] = isDrawerOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}